module.exports = "/images/vendor/vue-paycard/src/visa.png?513ff24e3863be5faced78a623b885ca";